import { useMemo } from 'react';
import type { LotsSource } from '@wavvest/wealth-ui';
import { CostBasisError, getBasisLot, getBasisLots } from './api';

/** Lot reads for one Apex account through the investor's own routes. */
export function useLotsSource(accountId?: string): LotsSource | undefined {
  return useMemo(
    () =>
      accountId
        ? {
            fetchPage: (filters, cursor) => getBasisLots(accountId, filters, cursor),
            fetchLot: (lotId) => getBasisLot(accountId, lotId),
            errorStatus: (error) => (error instanceof CostBasisError ? error.status : 0),
          }
        : undefined,
    [accountId],
  );
}
